"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemporaryConsumer = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("../utils/theme");
const css_manager_1 = require("@food/css-manager");
const Button_1 = require("@food/ui/build/dist/src/Button");
const style = (0, css_manager_1.registerClass)((theme, sc) => `
	.${sc('first-button')} {
		margin-right: ${(theme.ratios.xs / 2) * theme.font.baseSize}px;
	}
	
	.${sc('strong')} {
		font-weight: ${theme.font.weights.bold};
	}`);
const sc = (0, css_manager_1.currySC)(style);
const TemporaryConsumer = ({ t, isModal, proceed, supportEmail, workEmail, returnToAskEmail, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h2", null,
        t `Thanks for signing in`,
        "."),
    react_1.default.createElement("section", { className: style },
        t `We sent you a verification email to`,
        ' ',
        react_1.default.createElement("span", { className: sc('strong') }, workEmail),
        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                __html: t `Temporary consumer explanation`,
            } }),
        react_1.default.createElement("p", null,
            t `If you think we're wrong please`,
            ' ',
            react_1.default.createElement("a", { href: `mailto:${supportEmail}` }, t `contact us`),
            "."),
        react_1.default.createElement("div", { className: (0, css_manager_1.classNames)(theme_1.footer, (0, css_manager_1.subClass)(theme_1.footer, 'centered'), (0, css_manager_1.subClass)(style, 'buttons')) },
            react_1.default.createElement(Button_1.Button, { label: t `Change work email`, className: sc('first-button'), onClick: returnToAskEmail }),
            react_1.default.createElement(Button_1.Button, { label: t(isModal ? 'Close' : 'Proceed'), onClick: proceed })))));
exports.TemporaryConsumer = TemporaryConsumer;
//# sourceMappingURL=TemporaryConsumer.js.map